import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import config from '../../config';

// import IconLogo from './IconLogo';
import LogoImage from './revelo-logo.png';

import css from './Logo.module.css';

const Logo = props => {
  const { className, format, ...rest } = props;

  const classes = classNames(className, {
    [css.logoMobile]: format === 'mobile',
  });

  return <img className={classes} src={LogoImage} alt={config.siteTitle} {...rest} />;
};

const { oneOf, string } = PropTypes;

Logo.defaultProps = {
  className: null,
  format: 'desktop',
};

Logo.propTypes = {
  className: string,
  format: oneOf(['desktop', 'mobile']),
};

export default Logo;
